module.exports = __webpack_public_path__ + "static/taco-logo-fad788d9cccec6c3fc4aa188aa8130d7.jpg";